// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/mention/style/index.less
// module id = 1119
// module chunks = 1